// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.verification.email.enums.EmailVerificationType

export enum EmailVerificationType {
  ACCOUNT_EMAIL_CLAIM_LISTINGS = 'ACCOUNT_EMAIL_CLAIM_LISTINGS',
  /**
   * @deprecated
   */
  CLAIM_FEED_LISTINGS = 'CLAIM_FEED_LISTINGS',
  /**
   * @deprecated
   */
  DEFAULT = 'DEFAULT',
  LISTING_CLAIMING_PATH = 'LISTING_CLAIMING_PATH',
  LISTING_CONTACT = 'LISTING_CONTACT',
}

export const EmailVerificationType_values = [
  EmailVerificationType.ACCOUNT_EMAIL_CLAIM_LISTINGS,
  EmailVerificationType.CLAIM_FEED_LISTINGS,
  EmailVerificationType.DEFAULT,
  EmailVerificationType.LISTING_CLAIMING_PATH,
  EmailVerificationType.LISTING_CONTACT,
] as const;
